import { ResourceCard, type ResourceCardProps } from './ResourceCard';

export type ConditionalResourceCardProps = Omit<ResourceCardProps, 'className'> & {
  searchTerms: string[];
  facets?: string[];
  currentSearchTerm: string | null;
  currentFacet: string;
  className?: string;
};
export function ConditionalResourceCard({
  searchTerms,
  facets = ['all'],
  currentSearchTerm,
  currentFacet,
  className = 'mt-8',
  ...resourceCardProps
}: ConditionalResourceCardProps) {
  // Return null if no search term
  if (!currentSearchTerm) {
    return null;
  }

  // Check if the current facet matches
  const facetMatches = facets.includes(currentFacet);

  // Check if any search term matches (case-insensitive)
  const searchTermMatches = searchTerms.some(
    (term) => term.toLowerCase() === currentSearchTerm.toLowerCase()
  );

  // Only render if both conditions are met
  if (!facetMatches || !searchTermMatches) {
    return null;
  }

  return <ResourceCard {...resourceCardProps} className={className} />;
}
